<div class="custom-container" [ngClass]="{'!px-0': username}">
  @if(trendingProfile) {
  <vota-influencer-profile-card [profile]="trendingProfile"></vota-influencer-profile-card>
  <hr class="mt-4 mb-4" />
  } @if(!username){
  <h1 class="text-[32px] font-bold mb-5 dark:text-white">Raffles</h1>
  }
  <div class="flex flex-col gap-5 mb-5"
    [ngClass]="username ? 'min-h-[calc(100vh-525px)]' : 'min-h-[calc(100vh-228px)]'">
    @if(raffles$ | async; as raffles) { @for(raffle of raffles; track raffle.id)
    {
    <div class="bg-[#3D3D3D] rounded-lg text-white overflow-hidden cursor-pointer" (click)="onRaffleClick(raffle)">
      <div class="max-h-[180px] rounded-lg overflow-hidden">
        <img [src]="
            raffle.raffleImages.length > 0
              ? raffle.raffleImages[0].imageUrl
              : ''
          " alt="Image" class="max-h-[180px] w-full object-cover" />
      </div>
      <div class="px-3.5 py-2.5">
        <h3 class="text-lg font-bold mb-2.5">{{ raffle.title }}</h3>
        <p class="line-clamp-3 text-sm font-light mb-5">
          {{ raffle.description }}
        </p>
        <div class="flex items-center justify-between">
          @if((raffle?.raffleStatus === RaffleStatus.Ended)) {
          <span class="bg-[#929292] rounded-lg text-base font-bold py-1.5 px-4 inline-block">Raffle Ended
          </span>
          <mat-icon class="material-symbols-outlined text-white">
            call_made
          </mat-icon>
          } @else {
          <span class="bg-pink-200 rounded-lg text-base font-bold py-1.5 px-4 inline-block">{{
            raffle.ticketPrice > 0
            ? (raffle.ticketPrice | currency : "GBP" : "symbol" : "1.2-2")
            : "Free"
            }}
          </span>
          <mat-icon class="material-symbols-outlined text-white">
            call_made
          </mat-icon>
          }
        </div>
      </div>
    </div>
    } @empty { @if(!isLoading){
    <div class="h-full flex items-center justify-center flex-1">
      <span class="text-center">No Raffles found</span>
    </div>
    } } } @if(isLoading) {
    <div class="spinner h-full flex items-center justify-center flex-1">
      <mat-progress-spinner mode="indeterminate" diameter="40" color="primary"></mat-progress-spinner>
    </div>
    }
  </div>

  <vota-footer></vota-footer>
</div>